<template>
  <main-container>
    <a-card :bordered="false" style="margin-top: 24px">
      <Chart v-if="loading" :data="chartData" />
    </a-card>
    <!-- 表格 -->
    <a-card v-if="$route.query.range == 'm'">
      <a-button
        style="float:right"
        type="primary"
        @click="printDate = `${JSON.parse($route.query.param).year}-${JSON.parse($route.query.param).month}`"
        >打印</a-button
      >
    </a-card>
    <a-card>
      <a-table
        v-if="loading"
        row-key="id"
        :columns="columns"
        :data-source="dataSource"
        :expandedRowKeys="[expended]"
        :pagination="false"
      >
        <template slot="expandIcon">
          <div></div>
        </template>
        <!-- 操作 -->
        <template slot="action" slot-scope="row, item, index">
          <a-button
            v-if="$route.query.range == 'm'"
            type="link"
            @click="$router.push({ name: $routeName.dayOrder, query: { date: row.create_time } })"
          >
            查看
          </a-button>
          <a-button v-if="$route.query.range == 'y'" type="link" @click="getInnerData(row.create_time, index)">
            {{ expended == index ? '收起' : '查看' }}
          </a-button>
          <a-button v-if="$route.query.range == 'y'" type="link" @click="printDate = row.create_time">
            打印
          </a-button>
        </template>
        <!-- 嵌套表格 -->
        <a-table
          slot="expandedRowRender"
          row-key="id"
          :loading="innerLoading"
          :columns="columninner"
          :data-source="innerData"
          :pagination="false"
        >
          <template slot="action" slot-scope="record">
            <a-button
              type="link"
              @click="$router.push({ name: $routeName.dayOrder, query: { date: record.create_time } })"
            >
              查看
            </a-button>
          </template>
        </a-table>
      </a-table>
    </a-card>
    <Print :date="printDate" @printed="printDate = ''" />
  </main-container>
</template>

<script>
import Home from '@/api/home';

import Chart from './Chart';
import Print from './print';

var columns = [
  {
    title: '序号',
    dataIndex: 'num',
  },
  {
    title: '时间',
    dataIndex: 'create_time',
  },
  {
    title: '订单量',
    dataIndex: 'order_id',
  },
  {
    title: '订单金额',
    dataIndex: 'amount',
  },
  {
    title: '收入',
    dataIndex: 'income',
  },
  {
    key: 'action',
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];
var columninner = [
  {
    title: '时间',
    dataIndex: 'create_time',
  },
  {
    title: '订单量',
    dataIndex: 'order_id',
  },
  {
    title: '订单金额',
    dataIndex: 'amount',
  },
  {
    title: '收入',
    dataIndex: 'income',
  },
  {
    key: 'action',
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];
var columns2 = [
  {
    title: '序号',
    dataIndex: 'num',
  },
  {
    title: '时间',
    dataIndex: 'create_time',
  },
  {
    title: '订单号',
    dataIndex: 'order_id',
  },
  {
    title: '订单金额',
    dataIndex: 'amount',
  },
  {
    title: '收入',
    dataIndex: 'income',
  },
];

export default {
  name: 'OrderPurchase',
  components: {
    Chart,
    Print,
  },
  data() {
    return {
      columns,
      columninner,
      loading: false,
      innerLoading: false,
      dataSource: [],
      innerData: [],
      rangeTetx: '',
      chartData: [],
      expended: -1,
      printDate: '',
    };
  },
  created() {
    if (this.$route.query.range == 'm') {
      this.$route.meta.title = `${JSON.parse(this.$route.query.param).month}月订单列表`;
    } else if (this.$route.query.range == 'y') {
      this.$route.meta.title = `${JSON.parse(this.$route.query.param).year}年订单列表`;
    } else {
      this.columns = columns2;
      this.$route.meta.title = `今日订单列表`;
    }
    //拉取数据
    Home.chat(JSON.parse(this.$route.query.param)).then(res => {
      this.chartData = res.data.chat;
      this.dataSource = res.data.list;
      this.loading = true;
    });
    this.rangeTetx = this.$route.query.range;
  },
  methods: {
    //展开月订单后获取数据
    getInnerData(date, index) {
      if (this.expended == index) {
        this.expended = -1;
      } else {
        this.expended = index;
        this.innerLoading = true;
        var param = date.split('-');
        Home.chat({ year: param[0], month: param[1] }).then(res => {
          this.innerData = res.data.list;
          this.innerLoading = false;
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#data {
  width: 100%;
}
</style>
